export const documentLimits = {
    fileSizeLimit: 50 * 1024 * 1024,
    manyDocumentsUploadLimit: 10,
    documentsLimitPerType: 500,
    fileTypePattern: '.xls,.xlsx,.pdf,.csv,.doc,.docx,.ppt,.pptx'
};
